<template>
  <div>

    <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.number"
            :error-messages="numberErrors"
            :label="$t('global.number')"
            @input="$v.item.number.$touch()"
            @blur="$v.item.number.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <strong class="" >{{ $t('global.description') }}:</strong>
          <div>
            <quill-editor 
              v-model="item.description" 
              class="editorQuill" 
              :options="editorOptions" 
              @input="$v.item.description.$touch()">
            </quill-editor>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <strong class="" >{{ $t('global.descriptionfr') }}:</strong>
          <div>
            <quill-editor 
              v-model="item.descriptionfr" 
              class="editorQuill" 
              :options="editorOptions" 
              @input="$v.item.descriptionfr.$touch()">
            </quill-editor>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="item.subtitle"
            :error-messages="subtitleErrors"
            :label="$t('process.subtitle')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.subtitle.$touch()"
            @blur="$v.item.subtitle.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="item.subtitlefr"
            :error-messages="subtitlefrErrors"
            :label="$t('process.subtitlefr')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.subtitlefr.$touch()"
            @blur="$v.item.subtitlefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <h4 class="primary--text">{{ $t('global.controlsettings') }}</h4>
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="macrotypeSelectItems"
            v-model="item.action"
            :items="macrotypeSelectItems"
            :error-messages="actionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('macro.macrotype')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="optionSelectItems && !item.withoutModuleOnly"
            v-model="item.moduleRef"
            :items="optionSelectItems"
            :error-messages="actionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('process.moduleref')"
            item-text="name"
            item-value="@id"
          />
          <v-combobox
            v-else
            v-model="item.moduleRef"
            :items="optionSelectItems"
            :error-messages="actionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('process.moduleref')"
            item-text="name"
            item-value="@id"
            disabled
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('process.tempprogress') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.tempProgress"
                :error-messages="tempProgressErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
 
              <v-text-field
                v-model="item.validatorRef"
                :error-messages="validatorRefErrors"
                :label="$t('process.validator')"
                required
                @input="$v.item.validatorRef.$touch()"
                @blur="$v.item.validatorRef.$touch()"
              />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
              <v-text-field 
                v-model="item.actionRef"
                :error-messages="actionRefErrors"
                :label="$t('process.actionref')"
                required
                @input="$v.item.actionRef.$touch()"
                @blur="$v.item.actionRef.$touch()"
              />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('process.doorOpen') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.doorOpen"
                :error-messages="doorOpenErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('process.withoutModuleOnly') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.withoutModuleOnly"
                :error-messages="withoutModuleOnlyErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('process.movementpanel') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.movementPanel"
                :error-messages="movementPanelErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('process.logpanel') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.logPanel"
                :error-messages="logPanelErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
  </div>
  
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'

/*
const CustomTableCell = TableCell.extend({
  
  addAttributes() {
    return {
      // extend the existing attributes …
      ...this.parent?.(),

      // and add a new one …
      backgroundColor: {
        default: null,
        parseHTML: element => element.getAttribute('data-background-color'),
        renderHTML: attributes => {
          return {
            'data-background-color': attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          }
        },
      },
    }
  },
})
*/

export default {
  name: 'StepForm',
  mixins: [validationMixin],
  components: {
    Loading,
    quillEditor,
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.macrotypeGetSelectItems();
    this.optionGetSelectItems();

  },
  data() {
    return {
        name: null,
        namefr: null,
        number: null,
        action: null,
        moduleRef: null,
        tempProgress: null,
        movementPanel: null,
        logPanel: null,
        validator: null,
        actionRef: null,
        description: null,
        descriptionfr: null,
        subtitle: null,
        subtitlefr: null,
        doorOpen: null,
        withoutModuleOnly: null,
        content: '<h1>Some initial content</h1>',
        editorOptions: { 
          theme: 'snow', // Thème de l'éditeur
          placeholder: 'Insérer une description',
          modules: {       
            toolbar: 
            [             
              ['bold', 'italic','strike'],
              [{ 'list': 'bullet' }]
            ]}}
    };
  },
  computed: {
    isLoading() {
      return (
        this.isLoading_macrotype, this.isLoading_option
       );
    },
    ...mapFields('macrotype', {
      macrotypeSelectItems: 'selectItems',
      isLoading_macrotype : 'isLoading'
    }),
    ...mapFields('option',{
      optionSelectItems: 'selectItems',
      isLoading_option : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    namefrErrors() {
      const errors = [];
      if (!this.$v.item.namefr.$dirty) return errors;
      has(this.violations, 'namefr') && errors.push(this.violations.namefr);
      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    numberErrors() {
      const errors = [];
      if (!this.$v.item.number.$dirty) return errors;
      has(this.violations, 'number') && errors.push(this.violations.number);
      !this.$v.item.number.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    actionErrors() {
      const errors = [];
      if (!this.$v.item.action.$dirty) return errors;
      has(this.violations, 'action') && errors.push(this.violations.action);
      return errors;
    },
    moduleRefErrors() {
      const errors = [];
      if (!this.$v.item.moduleRef.$dirty) return errors;
      has(this.violations, 'moduleRef') && errors.push(this.violations.moduleRef);
      return errors;
    },
    actionRefErrors() {
      const errors = [];
      if (!this.$v.item.actionRef.$dirty) return errors;
      has(this.violations, 'actionRef') && errors.push(this.violations.actionRef);
      return errors;
    },
    tempProgressErrors() {
      const errors = [];
      if (!this.$v.item.tempProgress.$dirty) return errors;
      has(this.violations, 'tempProgress') && errors.push(this.violations.tempProgress);
      return errors;
    },
    movementPanelErrors() {
      const errors = [];
      if (!this.$v.item.logPanel.$dirty) return errors;
      has(this.violations, 'logPanel') && errors.push(this.violations.logPanel);
      return errors;
    },
    logPanelErrors() {
      const errors = [];
      if (!this.$v.item.movementPanel.$dirty) return errors;
      has(this.violations, 'movementPanel') && errors.push(this.violations.movementPanel);
      return errors;
    },
    validatorErrors() {
      const errors = [];
      if (!this.$v.item.validator.$dirty) return errors;
      has(this.violations, 'validator') && errors.push(this.violations.validator);
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.item.description.$dirty) return errors;
      has(this.violations, 'description') && errors.push(this.violations.description);
      return errors;
    },
    descriptionfrErrors() {
      const errors = [];
      if (!this.$v.item.descriptionfr.$dirty) return errors;
      has(this.violations, 'descriptionfr') && errors.push(this.violations.descriptionfr);
      return errors;
    },
    subtitleErrors() {
      const errors = [];
      if (!this.$v.item.subtitle.$dirty) return errors;
      has(this.violations, 'subtitle') && errors.push(this.violations.subtitle);
      return errors;
    },
    subtitlefrErrors() {
      const errors = [];
      if (!this.$v.item.subtitlefr.$dirty) return errors;
      has(this.violations, 'subtitlefr') && errors.push(this.violations.subtitlefr);
      return errors;
    },
    doorOpenErrors() {
      const errors = [];
      if (!this.$v.item.doorOpen.$dirty) return errors;
      has(this.violations, 'doorOpen') && errors.push(this.violations.doorOpen);
      return errors;
    },
    withoutModuleOnlyErrors() {
      const errors = [];
      if (!this.$v.item.withoutModuleOnly.$dirty) return errors;
      has(this.violations, 'withoutModuleOnly') && errors.push(this.violations.withoutModuleOnly);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      macrotypeGetSelectItems: 'macrotype/fetchSelectItems'
    }),
    ...mapActions({
      optionGetSelectItems: 'option/fetchSelectItems'
    }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      namefr: {
        required,
      },
      number: {
        required,
      },
      action: {
      },
      moduleRef: {
      },
      tempProgress: {
      },
      movementPanel: {
      },
      logPanel: {
      },
      validator: {
      },
      actionRef: {
      },
      description: {
      },
      descriptionfr: {
      },
      subtitle: {
      },
      subtitlefr: {
      },
      doorOpen: {
      },
      withoutModuleOnly: {
      },
    }
  },
  watch: {
  }
};
</script>

<style>
.ql-toolbar .ql-stroke {
    fill: none;
    stroke: #fff;
}

.ql-editor::before {
  color: white !important;
  opacity: 0.33;
}
</style>





